export const DISONA_MODAL_IDS = {
  TRADING_ACCOUNT: 'trading_account',
  TRADING_DEMO_1: 'demo',
  APP_MENU: 'app_menu',
  TRADING_ACCOUNT_SCREEN: 'trading-account-screen',
  INSTRUMENTS_LIST_SCREEN: 'instruments-list-screen',
  SIGNAL_FORM: 'signal-form',
};

export const COMMON_MODAL_IDS = {
  SESSION_EXPIRED: 'session-expired',
};
